// @flow
import React from 'react';

export const StringField = ({ nameField, userValue }: { nameField: string, userValue: Object }) => {
  const string = nameField === 'age' ? 'años' : '';
  return <div>{`${userValue.value} ${string}`}</div>;
};
